import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';
import { RoundReactionInterface } from 'src/app/core/interfaces';
import { ReactionEmoji } from 'src/app/core/constants';

@Injectable({
  providedIn: 'root',
})
export class RoundReactionBackendService {
  private readonly BASE_ADDRESS = '/round/reaction';

  /**
   * @description constructor of RoundReactionBackendService
   * @param {HttpBackendService} http - http backend service
   */
  constructor(private http: HttpBackendService) {}

  /**
   * @description sends a reaction to a round
   * @param {string} roundUUID
   * @param {ReactionEmoji} emoji
   * @returns {Promise<RoundReactionInterface>}
   */
  public sendReaction(roundUUID: string, emoji: ReactionEmoji): Promise<RoundReactionInterface> {
    return firstValueFrom(
      this.http.post<RoundReactionInterface>(`${this.BASE_ADDRESS}/send`, {
        roundUUID,
        emoji
      })
    );
  }

  /**
   * @description gets reactions for a round
   * @param {string} roundUUID
   * @returns {Promise<RoundReactionInterface[]>}
   */
  public getReactions(roundUUID: string): Promise<RoundReactionInterface[]> {
    return firstValueFrom(
      this.http.get<RoundReactionInterface[]>(`${this.BASE_ADDRESS}/${roundUUID}`)
    );
  }
}